import { defineStore } from 'pinia';

export interface SectionReference {
	id: string;
	label: string;
	element: HTMLElement;
}

export const usePageSectionsStore = defineStore('PageSectionsStore', () => {
	const activeTabId = ref<string>('overview');
	const hasFeaturesByCategory = ref(true);
	const isAutomaticScrollingInteracting = ref(false);

	const sectionRefs = reactive(new Map<string, HTMLElement>());

	const contextualHeaderLinks = computed(() => {
		return Array.from(sectionRefs.entries()).map(([id, element]) => ({
			route: id,
			label: element.getAttribute('data-section-name') || id
		}));
	});

	function setActiveTabId(tabId: string) {
		activeTabId.value = tabId;
	}

	function setHasFeaturesByCategory(value: boolean) {
		hasFeaturesByCategory.value = value;
	}

	function setAutomaticScrollingInteracting(value: boolean) {
		isAutomaticScrollingInteracting.value = value;
	}

	function setSectionRef(element: HTMLElement) {
		if (!element?.id) {
			console.warn('Attempted to set section ref with empty or invalid id');
			return;
		}

		sectionRefs.set(element.id, element);
	}

	function removeSectionRef(id: string) {
		sectionRefs.delete(id);
	}

	function clearSectionRefs() {
		sectionRefs.clear();
	}

	function getSectionRef(id: string): HTMLElement | undefined {
		return sectionRefs.get(id);
	}

	function getSectionIds(): string[] {
		return Array.from(sectionRefs.keys());
	}

	return {
		activeTabId,
		hasFeaturesByCategory,
		isAutomaticScrollingInteracting,
		sectionRefs,
		contextualHeaderLinks,
		setActiveTabId,
		setHasFeaturesByCategory,
		setAutomaticScrollingInteracting,
		setSectionRef,
		removeSectionRef,
		clearSectionRefs,
		getSectionRef,
		getSectionIds
	};
});
